/** Matches the icon syntax embedded in a section group name, e.g. `[icon=bolt]`. */
export const ICON_SYNTAX_PATTERN = /\[icon=([a-z0-9-]+)\]/i
